import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { signInAdminWithGoogle } from '../../services/authService';
import LandingHeaderSection from '../landingPage/landingHeaderSection';
import {
  LandingContainer,
  LandingPageRoot,
  LoginPageCard,
  LoginPageIntro,
  LoginPageSection,
  LoginPageSubtitle,
  LoginPageTitle,
} from '../landingPage/landingPage.styles';
import { ErrorMessage, Image, SocialButtons } from '../../styles/styles';
import googleLogo from '../../images/google_logo.png';

export function AdminLoginPage() {
  const { t } = useTranslation('registration');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleGoogle = async () => {
    setError('');
    setLoading(true);
    try {
      await signInAdminWithGoogle();
    } catch (err) {
      const closed =
        err?.code === 'auth/popup-closed-by-user' ||
        err?.code === 'auth/cancelled-popup-request' ||
        err?.code === 'auth/popup-blocked';
      if (!closed) {
        setError(
          err?.code === 'auth/admin-only'
            ? t('texts.adminGateDenied')
            : t('texts.adminGateError'),
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <LandingPageRoot>
      <LandingHeaderSection />
      <LandingContainer>
        <LoginPageSection>
          <LoginPageCard>
            <LoginPageIntro>
              <LoginPageTitle>{t('texts.adminGateTitle')}</LoginPageTitle>
              <LoginPageSubtitle>{t('texts.adminGateHint')}</LoginPageSubtitle>
            </LoginPageIntro>
            <SocialButtons outlineButton type="button" onClick={handleGoogle} disabled={loading}>
              <Image src={googleLogo} alt="" imgHeight="24px" />
              {loading ? t('texts.adminGateLoading') : t('buttons.signInGoogle')}
            </SocialButtons>
            {error ? <ErrorMessage>{error}</ErrorMessage> : null}
          </LoginPageCard>
        </LoginPageSection>
      </LandingContainer>
    </LandingPageRoot>
  );
}
